import { createRouter, createWebHistory } from 'vue-router';

import Login from '../views/Login.vue';
import Waitlist from '../views/Waitlist.vue';
import Reserve from '../views/Reserve.vue';
import Setting from '../views/Setting.vue';
import SsoCallback from '../views/SsoCallback.vue';
import Register from '../views/Register.vue';
import WailitHistory from '../views/WailitHistory.vue';

const routes = [
    { path: '/waitlist', name: 'waitlist', component: Waitlist },
    { path: '/waitlist-history', name: 'waitlist-history', component: WailitHistory },
    { path: '/reserve', name: 'reserve', component: Reserve },
    { path: '/login', name: 'login', component: Login },
    { path: '/setting', name: 'setting', component: Setting },
    { path: '/sso/callback', name: 'sso-callback', component: SsoCallback },
    { path: '/register', name: 'register', component: Register },
    { path: '/', redirect: '/login' },
    // { path: '/reserve', name: 'reserve', component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')},
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
